import styled from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { Flex, Text, type TextProps } from "@similarweb/ui-components/foundations";

import { integrationMaxWidth } from "../../manage-export/style";
import { Button } from "@similarweb/ui-components";

export const StyledManagementWrapper = styled.div`
    background-color: ${colorsPalettes.bluegrey[100]};
`;

export const StyledIntegrationTabContainer = styled.div`
    width: 100%;
`;

export const StyledTabContent = styled.div`
    flex: 1;
    overflow: hidden;
    margin-top: 8px;
    padding: 10px 0 0 0;
    border-radius: 6px 6px 0 0;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.carbon[500], 0.08)};

    & .react-tabs {
        height: 100%;
    }
`;

export const StyledManagementSectionsContainer = styled.div`
    margin: 0 auto;
    padding-top: 32px;
    width: 100%;

    ${integrationMaxWidth}
`;

export const StyledExcludeSelectWithLabel = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    margin-bottom: 8px;
`;

export const StyledSectionHeaderWrapper = styled.div`
    margin-bottom: 18px;
`;

export const StyledSectionTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    ${setFontVariant("h5", colorsPalettes.carbon[500])}
`;

export const StyledSettingTitle = styled.div`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])}
    margin-bottom: 18px;
`;

export const StyledSettingHeader = styled.div`
    display: inline-flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 18px;
`;

export const StyledWrapperContent = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const StyledIntegrationInfo = styled.span`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    line-height: 24px;
    width: fit-content;
    margin-bottom: 8px;
`;

export const StyledHeader = styled(Flex)`
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
`;

export const StyledHeaderButton = styled(Button)`
    max-width: unset;

    & > div {
        width: max-content;
    }
`;

export const StyledSelectedFields = styled.div<{ isDisabled?: boolean; isSelected: boolean }>`
    ${setFontVariant("subtitle1")};

    line-height: 24px;
    border-bottom: 1px solid ${({ isSelected }) => (isSelected ? colorsPalettes.carbon[500] : colorsPalettes.blue[500])};
    cursor: pointer;
    color: ${({ isSelected }) => (isSelected ? colorsPalettes.carbon[500] : colorsPalettes.blue[500])};

    opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
    pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "all")};

    &:hover {
        color: ${colorsPalettes.blue[500]};
        border-bottom: 1px solid ${colorsPalettes.blue[500]};
    }
`;

export const StyledArrow = styled.span`
    display: inline-block;
    margin-left: 8px;
`;

export const StyledDescription = styled.div`
    flex-wrap: wrap;
    display: flex;
    width: 100%;
    flex-direction: row;
`;

export const StyledSectionSubtitle = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    margin: 8px 0;
`;

export const CUSTOM_MODAL_STYLES = {
    content: { padding: "20px 16px 16px 24px", width: 562, border: 0 },
    overlay: {
        backgroundColor: rgba(colorsPalettes.midnight["300"], 0.7),
    },
};

export const CUSTOM_DETAILS_STYLES = {
    marginTop: "36px",
};

export const StyledManagementIntegrationContainer = styled.div<{ noPaddingBottom?: boolean }>`
    background-color: ${colorsPalettes.carbon[0]};
    padding: ${(p) => `27px 27px ${p.noPaddingBottom ? 0 : 27}px 27px`};
    margin-bottom: 38px;
    border-radius: 6px;
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.carbon[500], 0.08)};
`;

export const StyledTooltipTextShort = styled(Text).attrs<Partial<TextProps>>({
    fontVariant: "tooltip",
    maxWidth: "162px",
})``;

export const StyledEnrichmentHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
`;
